<div class="chapters">
  <app-view-chapters-list-item
    *ngFor="let chapter of (chapters$ | async); let i = index;"
    (click)="handleChapterClick(chapter)"
    [index]="i"
    [selected]="chapter.id === (selectedChapter$ | async)?.id"
    [chapter]="chapter"
    [thumbnail]="(thumbnails$ | async)?.get(chapter.id)"></app-view-chapters-list-item>
</div>